import { Utils } from "@/plugins/utils"

export default {
	namespaced: true,
	state: {},
	getters: {},
	mutations: {},
	actions: {
		async searchEligible({ dispatch }, { ofztabela, ofzordem = "", eqmsubclas = "", search = "", limit = 20, page = 1 }) {
			const url = `/OryxPlace/ProductionEquipment/SearchEligible?ofztabela=${ofztabela}&ofzordem=${ofzordem}&eqmsubclas=${encodeURIComponent(eqmsubclas || "")}&search=${encodeURIComponent(search)}&limit=${limit}&page=${page}`

			return await this._vm.$axios
				.get(url)
				.then(response => Utils.ValidateAxiosResponse(response.data))
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return { items: [], hasNext: false, limit }
				})
		},
		async findEligibleBySubclass({ dispatch }, { ofztabela, ofzordem = "", eqmsubclas }) {
			const url = `/OryxPlace/ProductionEquipment/FindEligibleBySubclass?ofztabela=${ofztabela}&ofzordem=${ofzordem}&eqmsubclas=${encodeURIComponent(eqmsubclas)}`

			return await this._vm.$axios
				.get(url)
				.then(response => Utils.ValidateAxiosResponse(response.data))
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return null
				})
		},
		async checkExpiration({ dispatch }, lstOfz) {
			return await this._vm.$axios
				.post("/OryxPlace/ProductionEquipment/CheckExpiration", lstOfz)
				.then(response => Utils.ValidateAxiosResponse(response.data))
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return []
				})
		},
	},
}
